import { atom } from "recoil"

export interface TermsState {
  isOpen: boolean
  step: 1 | 2
  isStep1Agreed: boolean
  isStep2Agreed: boolean
}

export const showTermsState = atom<TermsState>({
  key: "showTermsState",
  default: {
    isOpen: false,
    step: 1,
    isStep1Agreed: false,
    isStep2Agreed: false,
  },
})
